import { emailTemplateSchema } from "@redotech/redo-model/email-template";
import * as z from "zod/v4";

export const sendTestEmail = {
  name: "sendTestEmail" as const,
  input: z.object({
    emailAddress: z.email(),
    template: emailTemplateSchema
      .omit({ _id: true })
      .extend({ _id: z.string().optional() }),
    orderNumber: z.string().optional(),
  }),
  output: z.null(),
};
